import "./index.scss";
import { useContext, useEffect, useMemo, useState } from "react";
import { ProjectContext } from "context/ProjectProvider";
import { getActivitiesModifiedCount, getDashBoardDataV2 } from "services/auth";
import { useHistory, useParams } from "react-router";
import { AppContext } from "context/AppProvider";
import { Checkbox, Radio, RadioChangeEvent, Segmented, Tabs, Tag } from "antd";
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { client } from "services/axios";
import { BASE_URL } from "config/config";
import WelcomeStartupSetup from "components/welcome-startup-setup";
import ErrorBoundary from "components/error-boundary";
import { supersetEnv } from "utils/utils";
import ActionItems from "./action-items";
import RiskUpdateComponent from "../risk-update";
import AlertDashboard from "./alert/alert-dashboard";
import PlanningDataQualityReport from "./data-quality-report";
import {
  FilterNamesEnum,
  GcDashBoardType,
  NavigationPageEnum,
  EDashboardType
} from "../models";
import ProjectTimeline from "./time-line";

function GCProjectDashboard2() {
  const history = useHistory();
  const { projectId } = useParams() as any;
  const {
    tokenRetrievalState,
    projectDetails,
    projectToken,
    isFeatureFlagEnabled
  } = useContext(ProjectContext);

  const {
    setSubmittalListFilter,
    setMaterialListFilter,
    setBidPackageListFilter
  } = useContext(AppContext);
  const isMaterialProgressDashboardEnabled = isFeatureFlagEnabled(
    "MATERIAL_PROGRESS_DASHBOARD"
  );
  const isMaterialReadinessDashboardEnabled = isFeatureFlagEnabled(
    "MATERIAL_READINESS_DASHBOARD"
  );
  const isProcurementScheduleEnabled = isFeatureFlagEnabled(
    "PROCUREMENT_SCHEDULE"
  );
  const isSubmittalProgressDashboardEnabled = isFeatureFlagEnabled(
    "SUBMITTAL_PROGRESS_DASHBOARD"
  );

  const [dashboardData, setDashboardData] = useState<GcDashBoardType>();
  const [activitiesModifiedCount, setactivitiesModifiedCount] = useState();
  const [tabIndex, setTabIndex] = useState<string>("1");
  const [activeDashboard, setActiveDashboard] = useState<EDashboardType>(
    EDashboardType.Overview
  );

  const goToFiltered = (
    page: NavigationPageEnum,
    filter: FilterNamesEnum,
    value = undefined
  ) => {
    switch (page) {
      case NavigationPageEnum.MaterialLog:
        setMaterialListFilter({ key: filter.toString(), value });
        history.push("./materials");
        break;
      case NavigationPageEnum.SubmittalLog:
        setSubmittalListFilter({ key: filter.toString(), value });
        history.push("./submittals");
        break;
      case NavigationPageEnum.BidPackageLog:
        setBidPackageListFilter({ key: filter.toString(), value });
        history.push("./bid-packages");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const getDashBoardFuc = async () => {
      const response = await getDashBoardDataV2(tokenRetrievalState.token, {});

      if (response.success) {
        const { data } = response;
        setDashboardData(data.success);
      } else {
        console.log(response.error);
      }
    };

    const getActivitiesModified = async () => {
      const response = await getActivitiesModifiedCount(
        tokenRetrievalState.token,
        {}
      );
      if (response.success) {
        const { data } = response;
        setactivitiesModifiedCount(data.success);
      } else {
        console.log(response.error);
      }
    };

    if (tokenRetrievalState && tokenRetrievalState.token && projectDetails) {
      getDashBoardFuc();
      getActivitiesModified();
    }
  }, [tokenRetrievalState, projectDetails]);

  useEffect(() => {
    if (tabIndex === "1" && isMaterialProgressDashboardEnabled) {
      const container = document.getElementById(
        "material-progress-dashboard-container"
      );
      const executionDBPostData = async () => {
        try {
          if (!container) {
            console.error("Dashboard container not found.");
            return;
          }

          const tokens = await client.post(
            `${BASE_URL}/superset/dashboard`,
            {
              dashboard_no: 1
            },
            {
              headers: {
                Authorization: `Bearer ${projectToken}`,
                "Content-Type": "application/json"
              }
            }
          );

          embedDashboard({
            id: tokens.data.dashboard_id,
            supersetDomain: supersetEnv(),
            mountPoint: container,
            fetchGuestToken: () => Promise.resolve(tokens.data.token),
            dashboardUiConfig: {
              hideTitle: true,
              hideChartControls: false,
              hideTab: true
              // filters: {
              //   visible: false,
              //   expanded: false,
              //   allowEdit: false
              // }
            }
          });
        } catch (error) {
          console.error("Error posting data:", error);
          throw error;
        }
      };

      if (activeDashboard === EDashboardType.Overview) return;

      if (!container?.hasChildNodes()) {
        executionDBPostData();
      }
    }
  }, [
    activeDashboard,
    projectToken,
    tabIndex,
    isMaterialProgressDashboardEnabled
  ]);

  useEffect(() => {
    if (tabIndex === "2" && isSubmittalProgressDashboardEnabled) {
      const executionDBPostData = async () => {
        try {
          const waitForContainer = (): Promise<HTMLElement> => {
            return new Promise((resolve, reject) => {
              const maxAttempts = 10;
              let attempts = 0;

              const checkContainer = () => {
                const container = document.getElementById(
                  "submittal-progress-dashboard-container"
                );
                if (container) {
                  resolve(container);
                } else if (attempts < maxAttempts) {
                  attempts += 1;
                  setTimeout(checkContainer, 100);
                } else {
                  reject(
                    new Error("Dashboard container not found after waiting")
                  );
                }
              };

              checkContainer();
            });
          };

          const container = await waitForContainer();
          if (!container) {
            console.error("Dashboard container not found.");
            return;
          }

          const tokens = await client.post(
            `${BASE_URL}/superset/dashboard`,
            {
              dashboard_no: 6
            },
            {
              headers: {
                Authorization: `Bearer ${projectToken}`,
                "Content-Type": "application/json"
              }
            }
          );

          embedDashboard({
            id: tokens.data.dashboard_id,
            supersetDomain: supersetEnv(),
            mountPoint: container,
            fetchGuestToken: () => Promise.resolve(tokens.data.token),
            dashboardUiConfig: {
              hideTitle: true,
              hideChartControls: false,
              hideTab: true
            }
          });
        } catch (error) {
          console.error("Error posting data:", error);
          throw error;
        }
      };

      if (activeDashboard === EDashboardType.Overview) return;

      const container = document.getElementById(
        "submittal-progress-dashboard-container"
      );
      if (!container?.hasChildNodes()) {
        executionDBPostData();
      }
    }
  }, [
    activeDashboard,
    projectToken,
    tabIndex,
    isSubmittalProgressDashboardEnabled
  ]);

  useEffect(() => {
    if (tabIndex === "3" && isMaterialReadinessDashboardEnabled) {
      const planningDBPostData = async () => {
        try {
          const waitForContainer = (): Promise<HTMLElement> => {
            return new Promise((resolve, reject) => {
              const maxAttempts = 10;
              let attempts = 0;

              const checkContainer = () => {
                const container = document.getElementById(
                  "material-readiness-dashboard-container"
                );
                if (container) {
                  resolve(container);
                } else if (attempts < maxAttempts) {
                  attempts += 1;
                  setTimeout(checkContainer, 100);
                } else {
                  reject(
                    new Error("Dashboard container not found after waiting")
                  );
                }
              };

              checkContainer();
            });
          };

          const container = await waitForContainer();
          if (!container) {
            console.error("Dashboard container not found.");
            return;
          }

          const tokens = await client.post(
            `${BASE_URL}/superset/dashboard`,
            {
              dashboard_no: 4
            },
            {
              headers: {
                Authorization: `Bearer ${projectToken}`,
                "Content-Type": "application/json"
              }
            }
          );

          embedDashboard({
            id: tokens.data.dashboard_id,
            supersetDomain: supersetEnv(),
            mountPoint: container,
            fetchGuestToken: () => Promise.resolve(tokens.data.token),
            dashboardUiConfig: {
              hideTitle: true,
              hideChartControls: false,
              hideTab: true
              // filters: {
              //   visible: false,
              //   expanded: false,
              //   allowEdit: false
              // }
            }
          });
        } catch (error) {
          console.error("Error posting data:", error);
          throw error;
        }
      };

      if (activeDashboard === EDashboardType.Overview) return;

      const container = document.getElementById(
        "material-readiness-dashboard-container"
      );
      if (!container?.hasChildNodes()) {
        planningDBPostData();
      }
    }
  }, [
    activeDashboard,
    projectToken,
    tabIndex,
    isMaterialReadinessDashboardEnabled
  ]);

  const segmentOptions = useMemo(() => {
    const options: Array<{ label: React.ReactNode; value: EDashboardType }> = [
      { label: "Overview", value: EDashboardType.Overview }
    ];
    if (
      isMaterialProgressDashboardEnabled ||
      isMaterialReadinessDashboardEnabled ||
      isSubmittalProgressDashboardEnabled
    )
      options.push({
        label: (
          <div className="relative inline-flex items-center">
            Analytics
            <span className="pl-[5px]">
              <Tag>Beta</Tag>
            </span>
          </div>
        ),
        value: EDashboardType.Analytics
      });
    if (isProcurementScheduleEnabled)
      options.push({ label: "Timeline", value: EDashboardType.Timeline });
    return options;
  }, [
    isProcurementScheduleEnabled,
    isMaterialProgressDashboardEnabled,
    isMaterialReadinessDashboardEnabled,
    isSubmittalProgressDashboardEnabled
  ]);

  const analyticsTabItems = useMemo(() => {
    const items: Array<{
      key: string;
      label: string;
      children: React.ReactNode;
    }> = [];

    if (isMaterialProgressDashboardEnabled) {
      items.push({
        key: "1",
        label: "Material Progress",
        children: (
          <div
            id="material-progress-dashboard-container"
            className="w-full hideScroll !h-[73vh]"
          />
        )
      });
    }

    if (isSubmittalProgressDashboardEnabled) {
      items.push({
        key: "2",
        label: "Submittal Progress",
        children: (
          <div
            id="submittal-progress-dashboard-container"
            className="w-full hideScroll !h-[73vh]"
          />
        )
      });
    }

    if (isMaterialReadinessDashboardEnabled) {
      items.push({
        key: "3",
        label: "Material Readiness",
        children: (
          <div
            id="material-readiness-dashboard-container"
            className="w-full hideScroll !h-[73vh]"
          />
        )
      });
    }

    return items;
  }, [
    isMaterialProgressDashboardEnabled,
    isMaterialReadinessDashboardEnabled,
    isSubmittalProgressDashboardEnabled
  ]);

  useEffect(() => {
    if (analyticsTabItems.length > 0) {
      const validKeys = analyticsTabItems.map((item) => item.key);
      if (!validKeys.includes(tabIndex)) {
        setTabIndex(analyticsTabItems[0].key);
      }
    }
  }, [analyticsTabItems, tabIndex]);

  const [zoomSelection, setZoomSelection] = useState<string>("Quarter");
  const handleZoomChange = (e: RadioChangeEvent) => {
    const value = e.target.value as string;
    setZoomSelection(value);
  };

  return (
    <div className="flex flex-col h-full bg-white gc-project-dashboard">
      <div className="flex w-full py-2 px-6 font-medium items-center justify-between ">
        <div className="flex items-center">
          <div className="font-semibold text-xl pr-3">Dashboards</div>

          {segmentOptions.length > 1 && (
            <Segmented
              shape="round"
              size="large"
              options={segmentOptions}
              onChange={(value) => {
                console.log(value); // string
                setActiveDashboard(value as EDashboardType);
              }}
              data-testid="gc-project-dashboard-segmented"
            />
          )}
        </div>
        {activeDashboard === EDashboardType.Timeline && (
          <ErrorBoundary>
            <div className="flex items-center space-x-2">
              <div className="flex space-x-2 items-center bg-ciq-gray-500 bg-opacity-40 rounded px-4 py-2">
                <Checkbox
                  className="filterCheckbox font-normal"
                  name="HIGH"
                  data-testid="high-risk-checkbox"
                >
                  Filter High Risk
                </Checkbox>
              </div>
              <Radio.Group
                options={[
                  { value: "Months", label: "Months" },
                  { value: "Quarter", label: "Quarter" },
                  { value: "Year", label: "Year" }
                ]}
                value={zoomSelection}
                optionType="button"
                onChange={handleZoomChange}
                data-testid="timeline-zoom-radio"
              />
            </div>
          </ErrorBoundary>
        )}
      </div>
      {activeDashboard === EDashboardType.Overview && (
        <div className="w-full bg-white flex px-5 py-2 mb-8 hideScroll">
          <div className="h-full grow pr-5 space-y-5">
            <ErrorBoundary>
              <ActionItems
                projectId={projectId}
                dashboardData={dashboardData}
                projectDetails={projectDetails}
                goToFiltered={goToFiltered}
                hasBidPackageAccess
              />
            </ErrorBoundary>
            <ErrorBoundary>
              <RiskUpdateComponent
                dashboardData={dashboardData}
                goToFiltered={goToFiltered}
              />
            </ErrorBoundary>
          </div>
          <div className="h-full w-[500px]">
            <div className="">
              <ErrorBoundary>
                <AlertDashboard
                  projectId={projectId}
                  activities_modified={activitiesModifiedCount}
                  alerts={dashboardData?.alerts}
                  goToFiltered={goToFiltered}
                />
              </ErrorBoundary>
            </div>
            <div className="pt-10">
              <ErrorBoundary>
                <PlanningDataQualityReport
                  dashboardData={dashboardData}
                  goToFiltered={goToFiltered}
                />
              </ErrorBoundary>
            </div>
          </div>
        </div>
      )}
      {activeDashboard === EDashboardType.Analytics &&
        analyticsTabItems.length > 0 && (
          <ErrorBoundary>
            <div className="w-full pl-[10px]">
              <Tabs
                data-testid="index-tabs-gc-project-dashboard2"
                tabPosition="top"
                onChange={(activeKey) => {
                  setTabIndex(activeKey);
                }}
                activeKey={tabIndex}
                items={analyticsTabItems}
              />
            </div>
          </ErrorBoundary>
        )}

      {activeDashboard === EDashboardType.Timeline && (
        <ErrorBoundary>
          <ProjectTimeline zoomSelection={zoomSelection} />
        </ErrorBoundary>
      )}
      <WelcomeStartupSetup />
    </div>
  );
}
export default GCProjectDashboard2;
